{
    "ChangeLayoutOptionTitle": "Fare clic per visualizzare le opzioni di layout del Dashboard.",
    "NAME": "ChangeLayout"
}